<template>
  <h2 class="pb-2 border-bottom">Telemedicina</h2>
  <p>Telemedicina: atención accesible dondequiera que esté</p>
  <p>En Diverse Care Now, puede recibir atención médica desde casa en inglés, portugués o español.
  Nuestros servicios de telemedicina incluyen:</p>
  <ul>
    <li>Atención primaria general — consultas en línea para enfermedades comunes (resfriados, gripes, alergias), renovación de recetas, seguimiento de enfermedades crónicas (diabetes, hipertensión, tiroides) y orientación preventiva.</li>
    <li>Control de peso & salud metabólica — monitoreo virtual, prescripción segura (incluyendo terapias supervisadas por médicos), asesoría nutricional y programas supervisados.</li>
    <li>Salud de la mujer & del hombre — seguimiento de HRT y TRT, menopausia, SOP y equilibrio hormonal continuo.</li>
    <li>Salud mental & apoyo en el estilo de vida — consultas en línea para ansiedad, depresión, coaching de bienestar y calidad de vida.</li>
  </ul>
  <p>“Con nuestra plataforma segura de telemedicina, usted recibe la misma atención personalizada que en la clínica — pero desde la comodidad de su hogar.”</p>
</template>

<script>
export default {
  name: 'TelemedicineContentEs'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
